import React from 'react';
import { RadioButton } from '@progress/kendo-react-inputs';
import { useTranslation } from 'react-i18next';

const SharedPropertyTypeField = ({ value, onChange, disabled }) => {
    const { t } = useTranslation([
        "attribute/shared_property_field",
    ], {
        useSuspense: false
    })

    return (
        <div>
            <span className="me-4">
                <RadioButton
                    checked={value === "Tree Dropdown"}
                    value="Tree Dropdown"
                    label={t("tree_dropdown")}
                    onChange={onChange}
                    disabled={disabled} />
            </span>
            <span className="me-4">
                <RadioButton
                    checked={value === "Picklist String"}
                    value="Picklist String"
                    label={t("picklist_string")}
                    onChange={onChange}
                    disabled={disabled} />
            </span>
        </div>
    );
};

export default SharedPropertyTypeField;
